var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAutoRefreash(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2390_8619",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 26,
    height: 26
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.632812,
    y: 0.311035,
    width: 24.757,
    height: 24.757,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2390_8619)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.07614 20.4262C4.55508 20.4262 4.11403 20.2457 3.75299 19.8846C3.39195 19.5236 3.21143 19.0826 3.21143 18.5615V6.81784C3.21143 6.29678 3.39195 5.85572 3.75299 5.49468C4.11403 5.13364 4.55508 4.95312 5.07614 4.95312H20.946C21.467 4.95312 21.9081 5.13364 22.2691 5.49468C22.6302 5.85572 22.8107 6.29678 22.8107 6.81784V13.007H21.2634V8.5635H4.75871V18.5615C4.75871 18.6408 4.79177 18.7136 4.8579 18.7797C4.92403 18.8459 4.99678 18.8789 5.07614 18.8789H12.5746V20.4262H5.07614ZM19.8351 24.2349C18.6594 24.2349 17.6245 23.8736 16.7305 23.1508C15.8365 22.4281 15.256 21.5199 14.9888 20.4262H16.2703C16.5202 21.1893 16.9656 21.8098 17.6063 22.2879C18.2471 22.766 18.99 23.0051 19.8351 23.0051C20.8785 23.0051 21.7676 22.6377 22.5022 21.9031C23.2369 21.1684 23.6042 20.2794 23.6042 19.2359C23.6042 18.1925 23.2369 17.3035 22.5022 16.5688C21.7676 15.8342 20.8785 15.4668 19.8351 15.4668C19.2704 15.4668 18.7367 15.5885 18.2342 15.8318C17.7316 16.0752 17.2939 16.4032 16.9209 16.8158H18.6448V18.0457H14.8361V14.237H16.066V15.9251C16.5434 15.4186 17.1081 15.0106 17.7601 14.7011C18.4121 14.3917 19.1037 14.237 19.8351 14.237C21.2157 14.237 22.3941 14.7249 23.3701 15.7009C24.3461 16.6769 24.8341 17.8553 24.8341 19.2359C24.8341 20.6166 24.3461 21.795 23.3701 22.771C22.3941 23.7469 21.2157 24.2349 19.8351 24.2349Z",
    fill: "#666666"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAutoRefreash);
export default __webpack_public_path__ + "static/media/autoRefreash.5cf978d75f425d13ccd62fd14406a726.svg";
export { ForwardRef as ReactComponent };